import React, { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import AFooter from "../component/AFooter";

function Adminlogin() {
  const redirect = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("adminid")) {
      redirect("/dashboard");
    }
  });

  const [email, setemail] = useState('');
  const [password, setpassword] = useState('');

  function validation() {
    var ans = true;
    if (email == "") {
      toast.error("Email Field is required");
      ans = false;
      return false;
    }
    if (password == "") {
      toast.error("Password Field is required");
      ans = false;
      return false;
    }
    return ans;
  }

  const submithandle = async (i) => {
    i.preventDefault();
    if (validation()) {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);

      const res = await axios.post(
        `https://www.rajvicosmeticclinic.com/RajviApi/admin_login`, formData);

      if (res.data.status == false) {
        redirect('/admin-login');
        toast.error(res.data.message);
      }
      else {
        localStorage.setItem("adminid", res.data.id);
        localStorage.setItem("adminname", res.data.name);
        toast.success("Login Successfull");
        return redirect('/dashboard');;
      }

    }
  };
  return (
    <>
      <div className="container-fluid bg-light d-none d-lg-block">
        <div className="row py-2 px-lg-5">
          <div className="col-lg-6 text-left mb-2 mb-lg-0">
            <div className="d-inline-flex align-items-center">
              <small>
                <i className="fa fa-phone-alt mr-2" />
                +91 9106856105
              </small>
              <small className="px-3">|</small>
              <small>
                <i className="fa fa-envelope mr-2" />
                support@rajvicosmeticclinic.com
              </small>
            </div>
          </div>
          <div className="col-lg-6 text-right">
            <div className="d-inline-flex align-items-center">
              <a className="text-primary px-2" href>
                <i className="fab fa-facebook-f" />
              </a>
              <a className="text-primary px-2" href>
                <i className="fab fa-twitter" />
              </a>
              <a className="text-primary px-2" href>
                <i className="fab fa-linkedin-in" />
              </a>
              <a className="text-primary px-2" href>
                <i className="fab fa-instagram" />
              </a>
              <a className="text-primary pl-2" href>
                <i className="fab fa-youtube" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Topbar End */}
      {/* Navbar Start */}
      <div className="container-fluid p-0">
        <nav className="navbar navbar-expand-lg bg-white navbar-light py-3 py-lg-0 px-lg-5">
          <Link to="/admin-login" className="navbar-brand ml-lg-3">
            <h1 className="m-0 text-primary">
              <span className="text-dark">Rajvi</span> Cosmetic Clinic
            </h1>
          </Link>
        </nav>
      </div>
      {/* Navbar End */}
      {/* Header Start */}
      <div className="jumbotron jumbotron-fluid bg-jumbotron" style={{ marginBottom: 90 }}>
        <div className="container text-center py-5">
          <h3 className="text-white display-3 mb-4">Admin Login</h3>
          <div className="d-inline-flex align-items-center text-white">
            <p className="m-0"><a className="text-white" href>Home</a></p>
            <i className="far fa-circle px-3" />
            <p className="m-0">Admin Login</p>
          </div>
        </div>
      </div>

      {/* Contact Start */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-6" style={{ minHeight: 500 }}>
              <div className="position-relative h-100">
                <iframe
                  className="position-absolute w-100 h-100"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3001156.4288297426!2d-78.01371936852176!3d42.72876761954724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccc4bf0f123a5a9%3A0xddcfc6c1de189567!2sNew%20York%2C%20USA!5e0!3m2!1sen!2sbd!4v1603794290143!5m2!1sen!2sbd"
                  frameBorder={0}
                  style={{ border: 0 }}
                  allowFullScreen
                  aria-hidden="false"
                  tabIndex={0}
                />
              </div>
            </div>
            <div className="col-lg-6 pt-5 pb-lg-5">
              <div className="contact-form bg-light p-4 p-lg-5 my-lg-5">
                <h6 className="d-inline-block text-white text-uppercase bg-primary py-1 px-2">
                  Admin Login
                </h6>
                <h1 className="mb-4">Login Here</h1>
                <form method="post" name="sentMessage" onSubmit={submithandle}>
                  <div className="form-row">
                    <div className="col-sm-12 control-group">
                      <input
                        type="email"
                        className="form-control border-0 p-4"
                        id="email"
                        placeholder="Your Email"
                        onChange={(e) => setemail(e.target.value)}
                        name="email"
                      />
                      <p className="help-block text-danger" />
                    </div>
                    <div className="col-sm-12 control-group">
                      <input
                        type="text"
                        className="form-control border-0 p-4"
                        id="password"
                        placeholder="Your Password"
                        onChange={(e) => setpassword(e.target.value)}
                        name="password"
                      />
                      <p className="help-block text-danger" />
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary py-3 px-4"
                      type="submit"
                      id="sendMessageButton"
                    >
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}
      <AFooter />
    </>
  );
}

export default Adminlogin;
